// index

let dt_index = null;
let dt_deliveries = null;

export function index(){

    dt_index = $('#kiosks_table').DataTable({
        ajax: {
            url: $('#kiosks_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_kiosk_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[2, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_kiosks"]').click(delete_kiosks);
    });

    // dt_index.on('draw', function(e, settings){
    // });

}

function delete_kiosks(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = $(this).attr('route');

    let kiosks_id = [];
    $.each(rows_selected, function(index, rowId){
        kiosks_id.push(rowId);
    });
    
    if(kiosks_id.length == 0){

        window.messages.error(__('No has seleccionado ningún kiosco'));

    } else {

        const title = __('Eliminar zonas');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un kiosco.|[2,*] Estás a punto de eliminar :count kioscos.', kiosks_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    for(let kiosk_id of kiosks_id){
                        formData.append('kiosks_id[]', kiosk_id);
                    }

                    window.ajax.post(route, formData);

                }, 
                _ => {}
            );

    }

}

function render_kiosk_actions(data, type, row){

    const url_info = ($("#kiosks_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

// show

export function show(){

    dt_deliveries = $('#certificate_deliveries_table').DataTable({
        ajax: {
            url: $('#certificate_deliveries_table').attr('url'),
        },
        columns: [
            { width: '100', data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime },
            { width: '100', data: 'method', orderable: false, searchable: false },
            { data: 'type', orderable: false, searchable: false },
        ],
        order: [[0, 'desc']],
    });

    dt_deliveries.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.filters-container').remove();
    });

}